<template>
	<div v-bind:class="['input', { 'error': error }]">
		<label> {{ getText }}</label>
		<input
			:type="showPassword ? 'text' : 'password'"
			ref="input"
			:value="value"
			name="password"
			:autofocus=true
			v-on:input="change"
			v-on:keypress="reset"
			v-on:keydown.enter="enter">
		<span class="show-label" v-if="value.length > 0" @click="showPassword = !showPassword">
			{{ showPassword ? 'HIDE' : 'SHOW' }}
		</span>
		<label v-if="info" class="info">
			{{ info }}
		</label>
		<label v-if="error" class="error">
			{{ error }}
		</label>
		<label v-if="secondary" class="forgot"
			@click="altNext">
			{{ secondary }}
		</label>
	</div>
</template>

<script>
import AuthInput from '.'

export default {
	name: 'auth-password-input',
	extends: AuthInput,

	props: {
		info: {
			type: String,
		}
	},

	data() {
		return {
			type: 'password',
			showPassword: false
		}
	},
	methods: {
		reset() {
			this.$emit('reset')
		}
	},
	computed: {
		getText() {
			return this.title || 'Password'
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>
